module.exports = __webpack_public_path__ + "img/16.006c7a95.jpg";